<template>
  <div>
      <!-- 代码查看框 -->
    <Modal
        :scrollable="true"
        v-model="showModal"
        title="查看代码"
        width="800"
        >
        <div id='doc'></div>
    </Modal>
    <div v-if="list.body.id > 0 ">
    <center><h3>{{list.body.name}}</h3></center>
    <br />
    <Table :columns="columns1" :data="list.body.member" ></Table>
    </div>
    <div v-else>
        <center>暂无团队</center>
    </div>
  </div>
</template>
<script>
    import {nbNotebook} from "../../../../../assets/js/nbv"
    import {mapState,mapActions} from 'vuex'
    export default {
        data(){
            return {
                compet_id:0,
                showModal:false,
                // testJson:'{\"metadata\":{\"kernelspec\":{\"display_name\":\"Python 3\",\"language\":\"python\",\"name\":\"python3\"},\"language_info\":{\"name\":\"python\",\"version\":\"3.7.6\",\"mimetype\":\"text/x-python\",\"codemirror_mode\":{\"name\":\"ipython\",\"version\":3},\"pygments_lexer\":\"ipython3\",\"nbconvert_exporter\":\"python\",\"file_extension\":\".py\"}},\"nbformat_minor\":4,\"nbformat\":4,\"cells\":[{\"cell_type\":\"code\",\"source\":\"def output( param ):\\n   ## param会包含学生名称、输出结果路径等信息\\n   score=99     \\n   return score\\noutput(\\\"songlin\\\")\",\"metadata\":{\"trusted\":true},\"execution_count\":1,\"outputs\":[{\"execution_count\":1,\"output_type\":\"execute_result\",\"data\":{\"text/plain\":\"99\"},\"metadata\":{}}]}]}',
                columns1: [
                    {
                        title:"名称",
                        key:"name",
                    },
                    {
                        title:"类型",
                        key:"type",
                        render:(h,params)=>{
                            return h('div',params.row.is_leader ? "队长" : "队员")
                        }
                    },
                    {
                        title:"操作",
                        key:"edit",
                        render:(h,params)=>{
                            return h('div',[h('Button',{
                                props:{
                                type:'primary',
                                size:"small"
                            },
                            on: {
                                    click: () => {
                                        this.showCode(params.row)
                                    }
                                }
                            },"查看代码")])
                        }
                    }
                ],
            }
        },
        computed:{
            ...mapState({
                list:state=>state.team.myteam_list
            })
        },
        methods:{
            ...mapActions({
                getMyTeam:'team/getMyTeam',
                getTeamCode:'team/getTeamCode',
            }),
            showCode(params){
                let _this = this;
                console.log(params);
                if(this.list.body.id > 0){
                    this.getTeamCode({
                        data:{
                            team_id:this.list.body.id,
                            code_uuid:params.code_uuid,
                        },
                        callback:res=>{
                            _this.ipynb = JSON.parse(res.content);
                            let doc = document.getElementById("doc");
                            nbNotebook.render(this.ipynb,doc);
                        },
                        error:msg=>{
                            _this.$Message.error(msg);
                        }
                    })
                }
                
                
                
                this.showModal = true;
            },
            // 获取我的团队
            getList(){
                let _this = this;
                this.getMyTeam({
                    data:{
                        compet_id:_this.compet_id
                    }
                });
            }
        },
        mounted(){
            let _this = this;
            _this.compet_id = this.$route.params.id;
            if(_this.compet_id > 0){
                this.getList();
            }
        }
    }
</script>